/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../types';

import * as TypescriptOperationsGenerated from "graphql/typescript-operations.generated"
import * as Operations from 'graphql/document-nodes.generated';
import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router'
import { QueryHookOptions, useQuery } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient , ApolloClientContext} from 'withApollo';
export async function getServerPageGetGameMediaGallery
    (options: Omit<Apollo.QueryOptions<TypescriptOperationsGenerated.GetGameMediaGalleryQueryVariables>, 'query'>, ctx: ApolloClientContext ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<TypescriptOperationsGenerated.GetGameMediaGalleryQuery>({ ...options, query: Operations.GetGameMediaGalleryDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export const useGetGameMediaGallery = (
  optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetGameMediaGalleryQuery, TypescriptOperationsGenerated.GetGameMediaGalleryQueryVariables>) => {
  const router = useRouter();
  const options = optionsFunc ? optionsFunc(router) : {};
  return useQuery(Operations.GetGameMediaGalleryDocument, options);
};
export type PageGetGameMediaGalleryComp = React.FC<{data?: TypescriptOperationsGenerated.GetGameMediaGalleryQuery, error?: Apollo.ApolloError}>;
export const withPageGetGameMediaGallery = (optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetGameMediaGalleryQuery, TypescriptOperationsGenerated.GetGameMediaGalleryQueryVariables>) => (WrappedComponent:PageGetGameMediaGalleryComp) : NextPage  => (props) => {
                const router = useRouter()
                const options = optionsFunc ? optionsFunc(router) : {};
                const {data, error } = useQuery(Operations.GetGameMediaGalleryDocument, options)    
                return <WrappedComponent {...props} data={data} error={error} /> ;
                   
            }; 
export const ssrGetGameMediaGallery = {
      getServerPage: getServerPageGetGameMediaGallery,
      withPage: withPageGetGameMediaGallery,
      usePage: useGetGameMediaGallery,
    }